import { eventApi } from './Api';

const TransferService = (() => {
	function transferTicket(payload: any) {
		return eventApi.post(`/ticket-transfer`, payload);
	}

	function getTransferByToken(token: string) {
		return eventApi.get(`/ticket-transfer/${token}`);
	}

	function acceptTransfer(token: string) {
		return eventApi.post(`/ticket-transfer/${token}/accept`, {});
	}

	function cancelTransfer(transferId: number) {
		return eventApi.post(`/ticket-transfer/${transferId}/cancel`, {});
	}

	function getHistory(attendeeCode: string) {
		return eventApi.get(`/ticket-transfer/history`, { params: { attendeeCode } });
	}

	return {
		transferTicket: transferTicket,
		getTransferByToken: getTransferByToken,
		acceptTransfer: acceptTransfer,
		cancelTransfer: cancelTransfer,
		getHistory: getHistory,
	}
})();

export default TransferService;
